import keysCollection from '../../utilities/keysCollection'

export const Keys = keysCollection('USERS', {
    COMPANY: 'COMPANY'
})
